import React from 'react';
import { Link } from 'react-router-dom';


export default function GridTile(props) {
  return (
    <div className='masonry-tile'>
      <Link to={props.section + '/' + props.num}>
		     <img src={props.src} alt={'image # ' + props.num} draggable={false} />
      </Link>
		</div>
  );
};



// WEBPACK FOOTER //
// ./src/components/GridTile.js